import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api.js";

export interface Segment {
  id: string;
  name: string;
  displayOrder: number;
}

interface SegmentsResponse {
  items: Segment[];
}

export function useSegments() {
  return useQuery<Segment[]>({
    queryKey: ["segments"],
    queryFn: async () => {
      const res = await api.get<SegmentsResponse>("/segments");
      return res.items;
    },
    staleTime: 5 * 60 * 1000, // 5 min — Segments ändern sich praktisch nie
  });
}
